/**
 * Event Emitter created to emit events from the audio player component
 */
import EventEmitter from 'events';
export const eventBus = new EventEmitter();
